import React, { useState, useRef } from "react";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;

const translations = {
  en: {
    title: "Shradhanjali",
    subtitle: "Honoring Lives • Remembering Souls",
    ceremonies: "Ceremonies",
    family: "Family Members",
    tributes: "Tributes",
    writeTribute: "Write a tribute...",
    post: "Post",
    back: "Back",
  },
  hi: {
    title: "श्रद्धांजलि",
    subtitle: "जीवन का सम्मान • आत्मा की स्मृति",
    ceremonies: "संस्कार",
    family: "परिवार के सदस्य",
    tributes: "श्रद्धांजलि संदेश",
    writeTribute: "अपना संदेश लिखें...",
    post: "पोस्ट करें",
    back: "वापस",
  },
};

const dummyMemorials = [
  {
    id: 1,
    name: "Late Ramesh Sharma",
    place: "Mumbai",
    birth: "1955-06-12",
    death: "2023-09-20",
    about:
      "A loving father, teacher, and guide who touched many lives with kindness and wisdom.",
    about_hi:
      "एक प्रेमपूर्ण पिता, शिक्षक और मार्गदर्शक जिन्होंने अपने ज्ञान और दया से कई जीवनों को छुआ।",
    image:
      "https://images.unsplash.com/photo-1527980965255-d3b416303d12",
    shloka:
      "न जायते म्रियते वा कदाचित्\nनायं भूत्वा भविता वा न भूयः।\nअजो नित्यः शाश्वतोऽयं पुराणो\nन हन्यते हन्यमाने शरीरे॥",
    ceremonies: [
      { title: "10th Day Ritual (Daswan)", title_hi: "दसवां संस्कार", date: "2023-09-30" },
      { title: "13th Day Ritual (Terahvi)", title_hi: "तेरहवीं", date: "2023-10-03" },
      { title: "Bhajan / Kirtan", title_hi: "भजन / कीर्तन", date: "2023-10-05" },
      { title: "Community Feast", title_hi: "सामुदायिक भोज", date: "2023-10-06" },
    ],
    family: [
      { name: "Savitri Sharma", relation: "Wife", relation_hi: "पत्नी" },
      { name: "Amit Sharma", relation: "Son", relation_hi: "पुत्र" },
      { name: "Neha Sharma", relation: "Daughter", relation_hi: "पुत्री" },
    ],
    tributes: [
      {
        id: 1,
        text: "You will always live in our hearts ❤️",
        author: "Amit",
      },
    ],
  },
  {
    id: 2,
    name: "Late Shanta Devi",
    place: "Varanasi",
    birth: "1942-03-08",
    death: "2024-01-15",
    about:
        "A compassionate soul, devoted mother, and pillar of strength who nurtured generations with love, faith, and wisdom.",
    about_hi:
        "एक करुणामयी आत्मा, समर्पित माता और परिवार की शक्ति, जिन्होंने प्रेम, आस्था और ज्ञान से पीढ़ियों का मार्गदर्शन किया।",
    image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
    shloka:
        "वासांसि जीर्णानि यथा विहाय\nनवानि गृह्णाति नरोऽपराणि।\nतथा शरीराणि विहाय जीर्णा\nन्यानि संयाति नवानि देही॥",
    ceremonies: [
        { title: "10th Day Ritual (Daswan)", title_hi: "दसवां संस्कार", date: "2024-01-25" },
        { title: "13th Day Ritual (Terahvi)", title_hi: "तेरहवीं", date: "2024-01-28" },
        { title: "Special Pooja", title_hi: "विशेष पूजा", date: "2024-01-30" },
        { title: "Bhajan / Kirtan", title_hi: "भजन / कीर्तन", date: "2024-02-01" },
        { title: "Community Feast", title_hi: "सामुदायिक भोज", date: "2024-02-02" },
    ],
    family: [
        { name: "Late Ram Prasad", relation: "Husband", relation_hi: "पति" },
        { name: "Mahesh Kumar", relation: "Son", relation_hi: "पुत्र" },
        { name: "Sunita Verma", relation: "Daughter", relation_hi: "पुत्री" },
        { name: "Rohit Kumar", relation: "Grandson", relation_hi: "पोता" },
        { name: "Pooja Verma", relation: "Granddaughter", relation_hi: "पोती" },
    ],
    tributes: [
        {
        id: 1,
        text: "Your love and blessings will always guide us. You were the heart of our family.",
        author: "Mahesh",
        },
        {
        id: 2,
        text: "Nani, your stories and warmth will stay with me forever ❤️",
        author: "Pooja",
        },
        {
        id: 3,
        text: "A life well lived, full of devotion and kindness. Om Shanti 🙏",
        author: "Family Friend",
        },
        {
        id: 4,
        text: "You taught us patience, faith, and unconditional love. We are forever grateful.",
        author: "Sunita",
        },
        {
        id: 5,
        text: "Though you are not with us physically, your presence is felt in every prayer.",
        author: "Rohit",
        },
    ],
    }
];

export default function DigiMemorial() {
  const [memorials, setMemorials] = useState(dummyMemorials);
  const [selected, setSelected] = useState(null);
  const [newTribute, setNewTribute] = useState("");
  const [lang, setLang] = useState("en");

  const t = translations[lang];

  const toggleLang = () => {
    setLang((prev) => (prev === "en" ? "hi" : "en"));
  };

  // 🎤 Speech to Text
  const startListening = () => {
    if (!SpeechRecognition) {
      alert("Speech Recognition not supported in this browser");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = lang === "en" ? "en-US" : "hi-IN";
    recognition.start();

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setNewTribute((prev) => prev + " " + transcript);
    };

    recognition.current = recognition;
  };

  // 🔊 Text to Speech
  const speakText = (text) => {
    if (!window.speechSynthesis) return;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang === "en" ? "en-US" : "hi-IN";
    window.speechSynthesis.speak(utterance);
  };

  const addTribute = () => {
    if (!newTribute.trim()) return;

    const updated = memorials.map((m) => {
      if (m.id === selected.id) {
        return {
          ...m,
          tributes: [
            ...m.tributes,
            {
              id: Date.now(),
              text: newTribute,
              author: "You",
            },
          ],
        };
      }
      return m;
    });

    setMemorials(updated);
    setSelected(updated.find((m) => m.id === selected.id));
    setNewTribute("");
  };

  if (selected) {
    return (
    //   <div className="min-h-screen lg:min-h-[100vh] bg-black text-white [&_p]:text-white p-4">
      <div className="min-h-screen bg-black text-white [&_p]:text-white p-4 pb-28 md:pb-4">
        <div className="flex justify-between items-center mb-3">
          <button onClick={() => setSelected(null)} className="text-sm w-20 bg-blue-600 text-yellow-200">
            ← {t.back}
          </button>
          <button
            onClick={toggleLang}
            className="text-xs w-20 px-3 py-1 rounded-full bg-blue-500 shadow"
          >
            {lang === "en" ? "हिंदी" : "English"}
          </button>
        </div>

        <div className="text-center mb-3">
          <h1 className="text-lg lg:text-xl font-semibold text-cyan-100">🕊️ {t.title}</h1>
          <p className="text-xs text-gray-200 italic">Om Shanti Shanti Shanti</p>
        </div>
        
        <div className="bg-black rounded-xl p-3 mb-3 text-center text-sm text-gray-100 whitespace-pre-line">
          {selected.shloka}
          <button
            onClick={() => speakText(selected.shloka)}
            className="block mx-auto mt-2 text-xs bg-blue-500 text-yellow-200 w-10"
          >
            🔊 {t.listen}
          </button>
        </div>

        <div className="bg-black rounded-xl shadow-lg p-4 border border-gray-500 ">
          <img src={selected.image} alt="" className="w-full h-56 object-cover rounded-xl" />
          <h1 className="text-lg lg:text-xl font-semibold mt-2 text-cyan-200">{selected.name}</h1>
          <p className="text-sm text-gray-50">
            {selected.birth} - {selected.death} • {selected.place}
          </p>
          <p className="mt-2 text-gray-100 text-sm">
            {lang === "en" ? selected.about : selected.about_hi}
          </p>
        </div>

        <div className="mt-4 border border-gray-500 p-4">
          <h2 className="text-sm lg:text-lg font-medium text-cyan-200 mb-2">🪔 {t.ceremonies}</h2>
          {selected.ceremonies.map((c, i) => (
            <div key={i} className="bg-black p-2 rounded-xl shadow-sm flex justify-between mb-2">
              <span className="text-sm">
                {lang === "en" ? c.title : c.title_hi}
              </span>
              <span className="text-xs text-gray-50">{c.date}</span>
            </div>
          ))}
        </div>

        <div className="mt-4 border border-gray-500 p-4">
          <h2 className="text-sm lg:text-lg font-medium text-cyan-200 mb-2">👨‍👩‍👧 {t.family}</h2>
          {selected.family.map((f, i) => (
            <div key={i} className="bg-black p-2 rounded-xl shadow-sm flex justify-between mb-2">
              <span className="text-sm">{f.name}</span>
              <span className="text-xs text-gray-50">
                {lang === "en" ? f.relation : f.relation_hi}
              </span>
            </div>
          ))}
        </div>

         <div className="mt-4 border border-gray-500 p-4">
            <h2 className="text-sm lg:text-lg font-medium text-cyan-200 mb-2">🌼 {t.tributes}</h2>
            {selected.tributes.map((t) => (
                <div key={t.id} className="bg-black p-2 rounded-xl shadow-sm mb-2">
                    <p className="text-sm">{t.text}</p>
                    <span className="text-xs text-gray-50">— {t.author}</span>
                     <button
                        onClick={() => speakText(t.text)}
                        className="text-xs bg-blue-500 text-yellow-200 mt-1 w-10"
                    >
                        🔊 {t.listen}
                    </button>
                </div>
            ))}
        </div>

        {/* Input with STT */}
        <div className="fixed md:static bottom-0 left-0 right-0 bg-black/95 backdrop-blur p-3 border-t border-gray-700">
        {/* <div className="md:static fixed bottom-0 left-0 right-0 bg-black p-3 shadow-inner"> */}
          <div className="flex gap-2 items-center">
            <input
              value={newTribute}
              onChange={(e) => setNewTribute(e.target.value)}
              placeholder={t.writeTribute}
              className="flex-1 border rounded-lg px-3 py-2 text-sm text-black"
            />
            <button
              onClick={startListening}
              className="px-3 py-2 bg-blue-500 rounded-lg w-12"
            >
              🎤
            </button>
            <button
              onClick={addTribute}
              className="bg-amber-600 text-white px-4 py-2 rounded-lg text-sm w-24"
            >
              {t.post}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[100vh] bg-black text-white [&_p]:text-white">
      <div className="flex justify-between items-center mb-2">
        <div className="flex flex-col">
            <h1 className="flex text-start text-xl font-semibold text-red-500">🕊️ {t.title}</h1>
            <p className="text-xs text-gray-100 italic mb-2">{t.subtitle}</p>
        </div>
        <div>
            <button
                onClick={toggleLang}
                className="text-xs w-20 px-3 py-1 rounded-full bg-blue-500 shadow"
            >
                {lang === "en" ? "हिंदी" : "English"}
            </button>
        </div>
      </div>

      <div className="space-y-3">
        {memorials.map((m) => (
          <div
            key={m.id}
            onClick={() => setSelected(m)}
            className="bg-black rounded-xl border border-gray-400 shadow-md p-3 flex gap-3 cursor-pointer"
          >
            <img src={m.image} alt="" className="w-16 h-16 rounded-xl object-cover" />
            <div className="flex-1">
              <h2 className="text-sm font-semibold text-gray-100">{m.name}</h2>
              <p className="text-xs text-gray-50">{m.death} • {m.place}</p>
              <p className="text-xs text-gray-200 mt-1 line-clamp-2">
                {lang === "en" ? m.about : m.about_hi}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
